import { Autocomplete } from '@components/SearchBars';
import { beam } from '@styles/colors/themes';
import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';
import { ReactComponent as Loader } from '@assets/svg/loader.svg';

export const Container = styled.div`
  padding: 40px;
  background: #fff;

  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    padding: 24px;
    padding-top: 0;
  }
`;
Container.displayName = 'Container';
export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1b1c;
`;
Title.displayName = 'Title';

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 32px;
  padding-top: 8px;
`;
Head.displayName = 'Head';

export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
WarningText.displayName = 'WarningText';
// Todo: Typography PL300??
export const Text = styled(WarningText)`
  color: #474d66;
  font-size: 14px;
  font-weight: 300;
  width: fit-content;
  white-space: nowrap;
  &.no-margin {
    margin: 0;
  }
`;
// PL100??
export const SmallerText = styled(Text)`
  font-size: 12px;
  line-height: 18px;
  color: #696f8c;
  margin: 0;
`;
SmallerText.displayName = 'SmallerText';
export const LoadingDiv = styled.div`
  width: 64px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
LoadingDiv.displayName = 'LoadingDiv';

export const Loading = styled(Loader)`
  /* This is default size of loading gif. Because It has 2px padding on both sides. */
  height: 16px;
  width: 16px;
`;
Loading.displayName = 'Loading';

export const ButtonText = styled(WarningText)`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
  margin-left: 40px;
  cursor: pointer;
  margin-right: 16px;

  &.DeselectButton {
    color: #474d66;
    margin-right: 0;
    margin-left: 32px;
  }
`;
ButtonText.displayName = 'ButtonText';

export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
WarningBoldText.displayName = 'WarningBoldText';

export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
HeadRight.displayName = 'HeadRight';

export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;

export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  height: 42px;
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  align-items: center;

  :disabled {
    color: #c1c4d6;
    background-color: #edeff4;
  }
`;
Button.displayName = 'Button';

export const DeleteButton = styled.button`
  background: #d14343;
  color: #fff;
  height: 42px;
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  align-items: center;

  :disabled {
    color: #c1c4d6;
    background-color: #edeff4;
  }
`;
DeleteButton.displayName = 'DeleteButton';

export const WhiteButton = styled(Button)`
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  height: 42px;
  color: ${beam.font.primary};
  font-weight: 500;
`;

WhiteButton.displayName = 'WhiteButton';

export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const Search = styled.input`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  width: 429px;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const RecentSearchImg = styled.img`
  width: 12px;
  height: 12px;
  display: flex;
`;

RecentSearchImg.displayName = 'RecentSearchImg';

export const Line = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  /* Extra spacing w/inventory heading , making it 24px */
  margin-bottom: 8px;
`;
Line.displayName = 'Line';

// interface ICount {
//   isActive?: boolean;
// }

export const Count = styled.div`
  color: #1b203a;

  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;

  /* identical to box height */
`;

export const CountNumber = styled.div`
  color: #474d66;
  background: #edeff4;

  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  margin-left: 8px;
  /* identical to box height */

  /* neutral tones/default-white */

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  height: 18px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 6px;

  /* beam texts/text-blueish-gray */
  border-radius: 4px;
`;

export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  position: absolute;
  right: 6px;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 0;
`;

export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;

export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const RowDiv = styled.div`
  flex-direction: row;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
`;

export const RowDivPointer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: default;
  margin-right: 32px;
  padding: 0 6px 8px 6px;
  padding-bottom: 8px;
  border-bottom: transparent;

  align-items: center;
  gap: 3px;

  color: #1b203a;
  font-weight: 300;
  font-size: 12px;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
Divider.displayName = 'Divider';

// interface isActiveProps {
//   isActive?: boolean;
//   isDisabled?: boolean;
// }

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const MenuButton = styled.div`
  display: flex;
  height: 42px;
  width: 42px;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

interface IAddEquipmentWrapper {
  disabled: boolean;
}

export const AddEquipmentWrapper = styled.div<IAddEquipmentWrapper>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'cursor')};

  height: 42px;
  width: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchProducts = styled(Autocomplete)`
  flex-grow: 1;
  max-width: 271px;
`;
